export interface CronPreset {
  label: string;
  value: string;
}

export const CRON_PRESETS: CronPreset[] = [
  { label: 'Every minute (testing)', value: '* * * * *' },
  { label: 'Every hour', value: '0 * * * *' },
  { label: 'Every 4 hours', value: '0 */4 * * *' },
  { label: 'Daily at 7 am', value: '0 7 * * *' },
  { label: 'Daily at 8 am', value: '0 8 * * *' },
  { label: 'Daily at 8:30 am', value: '30 8 * * *' },
  { label: 'Daily at 9 pm', value: '0 21 * * *' },
  { label: 'Daily at 10:30 pm', value: '30 22 * * *' },
  { label: 'Every day at midnight', value: '0 0 * * *' },
  { label: 'Mondays at 9 am', value: '0 9 * * 1' },
  { label: 'Tuesdays at 9 am', value: '0 9 * * 2' },
  { label: 'Wednesdays at 9 am', value: '0 9 * * 3' },
  { label: 'Thursdays at 9 am', value: '0 9 * * 4' },
  { label: 'Fridays at 9 am', value: '0 9 * * 5' },
  { label: 'Saturdays at 9 am', value: '0 9 * * 6' },
  { label: 'Every Monday at midnight', value: '0 0 * * 1' },
  { label: 'Custom', value: '' },
];

const PRESET_LOOKUP: Map<string, string> = new Map(
  CRON_PRESETS.filter(p => p.value).map(p => [p.value, p.label]),
);

export function cronLabel(expression: string): string {
  return PRESET_LOOKUP.get(expression) ?? expression;
}
